import React, { Component } from 'react'
import { PageHeader, message, Icon } from 'antd'
const cardConfig = {
  width: 250,
  title:{
  },
  text:{
    color: 'gray'
  }
}

const textJsx = (cfg) =>{
  let map = {
    '00':'草稿',
    '01': '开信中',
    '02': '转出中',
    '10': '已生效',
    '50': '到期待轧账',
    '51': '已轧账/待清算',
    '59': '轧账失败',
    '60': '已清算',
    '80': '到期',
    '99': '作废'
  }
  let stutas = map[cfg.crdtStatus]
  return `
  <group>
    <rect>
      <rect style={{
        width: ${cardConfig.width},
        height: 20,
        fill: #00b34f,
        radius: [6, 6, 0, 0],
        cursor: 'move',
        stroke: #00b34f
      }} draggable="true">
        <text style={{
          marginTop: 2,
          marginLeft: 75,
          textAlign: 'center',
          fontWeight: 'bold',
          fill: '#fff' }}>${cfg.crdtCode}</text>
      </rect>
      <rect style={{
        width: ${cardConfig.width},
        stroke: #00b34f,
        fill: 'rgba(24,144,255,0.15)',
        radius: [0, 0, 6, 6],
      }}>
        <text style={{ marginTop: 10, marginLeft: 4, fill: 'gray', fontSize: 10}}>持有人: ${cfg.creditorNam}</text>
        <text style={{ marginTop: 10, marginLeft: 4, fill: 'gray', fontSize: 10}}>牛信面额: ${cfg.crdtAmt}</text>
        <text style={{ marginTop: 10, marginLeft: 4, fill: 'gray', fontSize: 10}}>持有金额: ${cfg.usableAmt}</text>
        <text style={{ marginTop: 10, marginLeft: 4, fill: 'gray', fontSize: 10}}>融资金额: ${cfg.fincAmt}</text>
        <text style={{ marginTop: 10, marginLeft: 4, fill: 'gray', fontSize: 10}}>转出累计金额: ${cfg.tranAmt}</text>
        <text style={{ marginTop: 10, marginLeft: 4, fill: ${cfg.crdtStatus=='99'?'red':'gray'}, fontSize: 10}}>牛信状态: ${stutas}</text>
      </rect>
    </rect>
  </group>
  `
}

export default class Supplier extends Component {
  treeDataHandler = (treeData) => {
    let data = {
      nodes: [],
      edges: []
    }
    data.nodes.push({
      ...treeData,
      id: treeData.crdtId
    })
    function loopHandler (tree) {
      if(!tree.children||tree.children.length==0) return 
      tree.children.map(el=>{
        data.nodes.push({
          ...el,
          id: el.crdtId
        })
        data.edges.push({ source: el.parentId, target: el.crdtId })
        loopHandler(el)
      })
    }
    loopHandler(treeData)
    console.log(data)
    return data
  }
  createG6 = (data) => {
        
    G6.registerNode(
      'rect-jsx',
      {
        jsx: textJsx
      }
    );

    const container = document.getElementById('container');
    const width = container.scrollWidth;
    const height = container.scrollHeight || 500;
    const graph = new G6.Graph({
      container: 'container',
      width,
      height,
      // fitCenter: true,
      modes: {
        default: [
          {
            // 定义展开/收缩行为
            type: 'collapse-expand',
          },
          'drag-canvas',
          'zoom-canvas',
        ],
      },
      defaultNode: {
        type: 'rect-jsx',
        labelCfg: {
          style: {
            fill: '#000000A6',
            fontSize: 10,
          },
        },
        style: {
          stroke: '#72CC4A',
          width: 150,
        },
      },
      defaultEdge: {
        // ...                 // 边的其他配置
        type: 'polyline',
        // 边样式配置
        style: {
          opacity: 0.6, // 边透明度
          stroke: '#00b34f', // 边描边颜色
          endArrow: true,
        },
      },
      layout: {
        type: 'dagre', // 布局类型
        rankdir: 'LR', // 自左至右布局，可选的有 H / V / LR / RL / TB / BT
        nodesep: 60,
        ranksep: 100,
        sortByCombo: true
        // direction: 'TB', // 自左至右布局，可选的有 H / V / LR / RL / TB / BT
        // nodeSep: 50, // 节点之间间距
        // rankSep: 100, // 每个层级之间的间距
      },
    });
    graph.on('click', function(evt) {
      let record = evt.item._cfg.model
      console.log(record)
      tool.popUIByUcv('scfp_UI_053001', {record}, '信详情');
    });
    graph.data(data);
    graph.render();

    if (typeof window !== 'undefined')
      window.onresize = () => {
        if (!graph || graph.get('destroyed')) return;
        if (!container || !container.scrollWidth || !container.scrollHeight) return;
        graph.changeSize(container.scrollWidth, container.scrollHeight);
      };
  }
  componentDidMount(){
    let uuid = this.props.location.query.uuid
    let query = tool.getRouterQuery(uuid)
    console.log(query.treeData)
    let data = this.treeDataHandler(query.treeData)
    this.createG6(data)
  }
  render() {
    return (
      <div>
        <span onClick={()=>tool.go(-1)} style={{cursor: 'pointer'}}>
          <Icon type="arrow-left" />
          返回
        </span>
        <div id="container"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/component/FlowChart/index.js